import Image from 'next/image'
import { FC, memo } from 'react'

import { BASE_URL } from '@/shared/lib/const/env'

import { AllAcsCatBlockProps } from '../../types'
import { AccordionMenu } from '../AccordionMenu/AccordionMenu'
import { AcsNavItem } from '../AcsNavItem/AcsNavItem'

import cl from './style.module.scss'

export const AcsNavMenu: FC<AllAcsCatBlockProps> = memo(({ items }) => {
	return (
		<>
			<ul className={cl.list}>
				{items?.map(item => {
					if (!item.CATEGORIES.length) return null
					return (
						<>
							<li className={cl.item} key={item.PICTURE + item.NAME}>
								<AccordionMenu
									title={
										<div className={cl.wrapper}>
											{item.PICTURE && (
												<Image src={BASE_URL + item.PICTURE} alt={''} width={24} height={24} className={cl.img} />
											)}
											{item.NAME}
										</div>
									}>
									<AcsNavItem {...item} />
								</AccordionMenu>
							</li>
						</>
					)
				})}
			</ul>
		</>
	)
})
